export default __webpack_public_path__ + "static/media/cofactr_logo.1ea79386.png";